<div class="no-access-alert-container">
    <div class="no-access-alert-box">
        <i class="far fa-times-circle no-access-alert-icon"></i>
        <span class="no-access-alert-text">{{ alertText }}</span>
    </div>
</div>

